import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik"; // Import useField from Formik

const InputField = ({ label, as: Component = "input", ...props }) => {
  // Use useField to connect to Formik
  const [field, meta] = useField(props);

  return (
    <div className="input-field">
      {label && <label htmlFor={props.id}>{label}</label>}
      {/* Use the provided component type (input or select) */}
      <Component {...field} {...props} />
      {/* Display error message if the field has been touched and there's an error */}
      {meta.touched && meta.error && (
        <div className="error-message">{meta.error}</div>
      )}
    </div>
  );
};

InputField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  as: PropTypes.elementType, // Default to 'input'
};

export default InputField;
